// based on the code from gaspartripodiglobant here:
// https://github.com/mlegenhausen/fetch-intercept/issues/60

// some code here: https://github.com/mlegenhausen/fetch-intercept/issues/39
// DOES NOT WORK! Can't figure out original request url when there are parallel
// requests.

// could try using this patching tool https://www.npmjs.com/package/patch-package
// to make vectorGrid use our axios code directly.

// note -- to refresh token or see if we need to log out, we are just making an
// "overlay" request with our axios version. Kind of clunky that way, but whatever..

import fetchIntercept from 'fetch-intercept';
import TokenService from "src/services/token";
import instance from "src/services/instance"

// import { refresh, REFRESH_URL } from '...';

// interface IDataRequest {
//     [key: string]: Request;
// }

export const CreateInterceptors = (() => {
    let fetch_instance;

    const init = () => {
        let isRefreshing = false;
        let refreshSubscribers = [];
        let dataRequests = {}; // as IDataRequest;

        const logoutUser = () => {
            console.log("logout method here");
            //TokenService.removeUser();
            //navigate("/login")
            // Not needed since we try to refresh by making an api call. So,
            // we get logged out there
        };

        const subscribeTokenRefresh = callback => {
            refreshSubscribers.push(callback);
        };

        const onRefreshed = () => {
            refreshSubscribers.map(callback => callback());
            refreshSubscribers = [];
        };

        const removeDataRequestsItem = requestKey => {
            const { [requestKey]: _omit, ...remaining } = dataRequests;
            dataRequests = remaining;
        };

        const getRelativeUrl = url => url.replace(window.location.origin, '');

        return {
            registerInterceptors: () => {
                fetchIntercept.register({
                    request(url, config) {
                        if (config) {// && url.indexOf(REFRESH_URL) === -1) {
                            dataRequests = {
                                ...dataRequests,
                                [`${getRelativeUrl(url)}_${config.method || 'GET'}`]: config,
                            };
                        }
                        const headers = {
                            'Authorization': 'Bearer ' + TokenService.getLocalAccessToken()
                        }
                        return [url, { headers, ...config }];
                        //return [url, config];
                    },

                    response(response) {
                        const requestKey = `${getRelativeUrl(response.url)}_${response.request.method}`;
                        console.log("status: " + response.status);
                        if (response.status === 401) {// && response.url.indexOf(REFRESH_URL) === -1) {
                            console.log("status 401");
                            // wolf note: We really just want to refresh once when there are parallel requests.
                            // I'm not sure if this part "(!isRefreshing)" is working correctly, however.
                            // work okay. TODO - sort this out!
                            if (!isRefreshing) {
                                isRefreshing = true;
                                console.log("refreshing...");
                                //const data = instance.get("overlay/?format=json&latitude=0&longitude=0").then((response) => response.data);
                                instance.get("overlay/?format=json&latitude=0&longitude=0")
                                    .then(() => {
                                        isRefreshing = false;
                                        onRefreshed();
                                    })
                                    .catch(() => logoutUser());
                            }
                            const retryOrigReq = new Promise((resolve, reject) => {
                                subscribeTokenRefresh(() => {
                                    fetch(response.url, {
                                        ...dataRequests[requestKey],
                                    })
                                        .then(origReqResponse => {
                                            resolve(origReqResponse);
                                            removeDataRequestsItem(requestKey);
                                        })
                                        .catch(err => {
                                            reject(err);
                                        });
                                });
                            });
                            return retryOrigReq;
                        }
                        removeDataRequestsItem(requestKey);
                        return response;
                    },
                });
            },
        };
    };

    return {
        getInstance() {
            if (!fetch_instance) {
                fetch_instance = init();
            }
            return fetch_instance;
        },
    };
})();